"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Sizes = Object.freeze({
  EXTRASMALL: 'extraSmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});
var SizePropType = _propTypes["default"].oneOf(Object.values(Sizes));
var _default = exports["default"] = SizePropType;